export enum RecipientTypeEnum {
	CLIENT = "client",
	GUARANTOR = "guarantor",
}
